import React from 'react'

import style from './AccessPermissionGroup.module.css'

export default function AccessPermissionGroup({ index, item }) {
  return (
    <section
      className={`${style.container} js-access-permission-group-${index}`}
    >
      <header className={`${style.heading} js-permission-title`}>
        {item.header}
      </header>
      <div className={style.cardBody}>
        <ul className={style.list}>
          {item.description.split('; ').map((item, i) => (
            <li className={`js-permission-name-${i}`} key={i}>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
